import { useState, useEffect } from 'react';

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const [isDark, setIsDark] = useState(() => {
        if (typeof window !== 'undefined') {
            return document.documentElement.classList.contains('dark') ||
                localStorage.getItem('theme') === 'dark';
        }
        return false;
    });

    useEffect(() => {
        if (isDark) {
            document.documentElement.classList.add('dark');
            localStorage.setItem('theme', 'dark');
        } else {
            document.documentElement.classList.remove('dark');
            localStorage.setItem('theme', 'light');
        }
    }, [isDark]);

    return (
        <nav className="fixed w-full z-50 border-b-2 border-black dark:border-white bg-background-light/90 dark:bg-background-dark/90 backdrop-blur-sm">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-20 items-center">
                    <div className="flex-shrink-0 flex items-center gap-4">
                        <span className="font-display font-bold text-3xl tracking-tighter hover:text-accent transition-colors cursor-pointer">WR.</span>
                    </div>

                    <div className="hidden sm:flex items-center space-x-8">
                        <a className="font-bold text-lg hover:underline decoration-4 decoration-accent underline-offset-4" href="#home">Home</a>
                        <a className="font-bold text-lg hover:underline decoration-4 decoration-secondary underline-offset-4" href="#projects">Projects</a>
                        <a className="font-bold text-lg hover:underline decoration-4 decoration-accent underline-offset-4" href="#experience">Experience</a>
                        <a className="font-bold text-lg hover:underline decoration-4 decoration-secondary underline-offset-4" href="#connect">Connect</a>

                        {/* Dark Mode Toggle */}
                        <button
                            onClick={() => setIsDark(!isDark)}
                            className="ml-4 px-3 py-1 border-2 border-black dark:border-white bg-white dark:bg-black shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-[2px_2px_0px_0px_rgba(255,255,255,1)] hover:translate-x-[1px] hover:translate-y-[1px] hover:shadow-none transition-all"
                        >
                            <span className="material-icons text-xl align-middle">
                                {isDark ? 'light_mode' : 'dark_mode'}
                            </span>
                        </button>
                    </div>

                    <div className="sm:hidden flex items-center gap-4">
                        <button
                            onClick={() => setIsDark(!isDark)}
                            className="px-2 py-1 border-2 border-black dark:border-white bg-white dark:bg-black shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-[2px_2px_0px_0px_rgba(255,255,255,1)]"
                        >
                            <span className="material-icons text-lg align-middle">
                                {isDark ? 'light_mode' : 'dark_mode'}
                            </span>
                        </button>
                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="p-2 rounded-none text-black dark:text-white hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black focus:outline-none ring-2 ring-black dark:ring-white"
                            type="button"
                        >
                            <span className="sr-only">Open main menu</span>
                            <i className="material-icons">{isOpen ? 'close' : 'menu'}</i>
                        </button>
                    </div>
                </div>
            </div>
            {/* Mobile menu */}
            {isOpen && (
                <div className="sm:hidden border-t-2 border-black dark:border-white bg-background-light dark:bg-background-dark">
                    <div className="px-2 pt-2 pb-3 space-y-1">
                        <a className="block px-3 py-2 font-bold text-lg hover:bg-accent hover:text-black transition-colors" href="#home" onClick={() => setIsOpen(false)}>Home</a>
                        <a className="block px-3 py-2 font-bold text-lg hover:bg-secondary hover:text-white transition-colors" href="#projects" onClick={() => setIsOpen(false)}>Projects</a>
                        <a className="block px-3 py-2 font-bold text-lg hover:bg-accent hover:text-black transition-colors" href="#experience" onClick={() => setIsOpen(false)}>Experience</a>
                        <a className="block px-3 py-2 font-bold text-lg hover:bg-secondary hover:text-white transition-colors" href="#connect" onClick={() => setIsOpen(false)}>Connect</a>
                    </div>
                </div>
            )}
        </nav>
    );
}